'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGdprExplicitConsentRequired = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGdprExplicitConsentRequired = exports.getGdprExplicitConsentRequired = (0, _getIn2.default)(_keyPaths.GDPR_EXPLICIT_CONSENT_REQUIRED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/message/getGdprExplicitConsentRequired.js
// module id = 1068
// module chunks = 2 3